module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS2.9ce09cad.jpg";